import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import * as Icon from 'react-icons/fi';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'underscore';

import { Table, Customer } from 'services/action';

import useTable from 'ui/components/table';
import { SkeletonTable } from 'ui/components/skeleton';

import tableConfig from './component/detail/address/table.config';

import DetailLayout from './detail.layout';
import ActionCreate from './component/create/action';

const initialState = {
  customer: null,
  data: null,
  privilege: null,
};

const Action = ({ loading, data }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateTable = useSelector(
    (state) => state?.Table?.data['customer.location']
  );
  const [{ privilege }, setState] = React.useState(initialState);

  const $getPrivilege = async () => {
    const payload = {};

    const location = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.location',
    });

    if (location) {
      payload.location = location;
    }

    setState((prevState) => ({
      ...prevState,
      privilege: payload,
    }));
  };

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  if (loading) return null;

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id={`tooltip-top`}>Kembali</Tooltip>}
      >
        <Link to={`/master/customer`} className="btn btn-secondary px-2">
          <Icon.FiChevronsLeft size="17" />
        </Link>
      </OverlayTrigger>
      {(privilege?.location?.action === 'manage' || !Session?.privileges) && (
        <ActionCreate
          onClose={() =>
            Dispatch(Table.$reload('customer.location', StateTable))
          }
          data={data}
        />
      )}
    </>
  );
};

const DetailAddress = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const LocationTable = useTable('customer.location', tableConfig, false);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Customer.Show']
  );

  const [{ customer }, setState] = React.useState(initialState);

  const $onLoad = async (id) => {
    const req = await Dispatch(Customer.$show(id));
    if (req?.message === 'success' && req?.data) {
      setState((prevState) => ({ ...prevState, customer: req?.data }));
    } else {
      History.push(`/master/customer`);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);

    const filters = {
      customer_id: match?.params?.id,
      exlude: 'hub',
    };

    LocationTable.boot(filters);
  }, []);

  return (
    <DetailLayout
      customer_id={customer?.id}
      action={<Action handleUpdated={$onLoad} data={customer} />}
    >
      {StateLoading ? (
        <SkeletonTable headerCount={9} bodyCount={9} />
      ) : (
        <>
          <LocationTable.Tools
            isLoading={StateLoading}
            searchable
            downloadable
          />
          <LocationTable.Render />
        </>
      )}
      <div className="p-3 border-top">
        <LocationTable.Pagination />
      </div>
    </DetailLayout>
  );
};

export default DetailAddress;
